// Fachada PIX: Mercado Pago por padrão, Asaas desativado (rollback via
// REACT_APP_PIX_PROVIDER=asaas). Mantém os services Asaas intactos.
import { asaasGeneratePixPayment } from "../asaas/asaasGeneratePixPayment";
import { asaasGetPaymentInfos } from "../asaas/asaasGetPaymentInfos";
import { assasVerifyPayment } from "../asaas/assasVerifyPayment";
import { mpGeneratePixPayment } from "../mercadopago/mpGeneratePixPayment";
import { mpGetPaymentInfos } from "../mercadopago/mpGetPaymentInfos";
import { mpVerifyPayment } from "../mercadopago/mpVerifyPayment";

const useMercadoPago =
  String(
    process.env.REACT_APP_PIX_PROVIDER || "mercadopago"
  ).toLowerCase() !== "asaas";

// Pago no Asaas = RECEIVED/CONFIRMED. Pago no Mercado Pago = approved.
const isPixPaidStatus = (status) =>
  status === "RECEIVED" || status === "CONFIRMED" || status === "approved";

const generatePixPayment = async (params) => {
  if (useMercadoPago) return mpGeneratePixPayment(params);
  return asaasGeneratePixPayment(params);
};

const getPixPaymentInfos = async (params) => {
  if (useMercadoPago) return mpGetPaymentInfos(params);
  return asaasGetPaymentInfos(params);
};

const verifyPixPayment = async (params) => {
  if (useMercadoPago) return mpVerifyPayment(params);
  return assasVerifyPayment(params);
};

export {
  generatePixPayment,
  getPixPaymentInfos,
  verifyPixPayment,
  isPixPaidStatus,
  useMercadoPago,
};
